import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
  Spinner,
  Badge,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
//import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import * as employeeReportAction from "../../store/ZW1wbG95ZWVSZXBvcnQ/actions"
import { isEmpty } from "lodash"
import { ToastContainer } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import api from "helpers/Api"

const EmployeeReport = (props) => {
  const { SearchBar } = Search
  const { dispatch, searchBtnStyle } = props

  const title = "Employee Report"

  useEffect(() => {
    dispatch(employeeReportAction.loadRecordsMetaData())
    dispatch(
      employeeReportAction.loadRecords({
        isManageHRMS: true,
        status: "active"
      })
    )
  }, [])

  //Reducer States
  const update = useSelector((specificstate) => specificstate.employeeReport)

  const { recordsMetaData = {}, employee_report = [] } = update

  //Handle Change
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [department, setDepartment] = useState([])
  const [designation, setDesignation] = useState([])
  const [city, setCity] = useState([])
  const [employeeActive, setEmployeeActive] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [employeeData, setEmployeeData] = useState({
    fromDate: "",
    toDate: "",
  })

  const statusList = [
    {
      label: "Inactive Employees",
      value: true,
    },
  ]

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked
    console.log(e, "value")
    console.log("chooseData handle isChecked ", isChecked)
    if (isChecked) {
      setEmployeeActive(value)
      // setAuditChecked(true)
    } else {
      setEmployeeActive(false)
    }
    console.log("choose value", value)
  }

  console.log(employeeData, "employeeData")
  //handle Change
  const handleChange = async (e) => {
    setEmployeeData({ ...employeeData, [e.target.name]: e.target.value })
  }

  //Service modal

  const companies = !isEmpty(company) && company.map((data) => data.value)
  const branches = !isEmpty(branch) && branch.map((data) => data.value)
  const departments =
    !isEmpty(department) && department.map((data) => data.value)
  const designations =
    !isEmpty(designation) && designation.map((data) => data.value)
  const cities = !isEmpty(city) && city.map((data) => data.value)
  //dropdown options api
  const branchListOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId === company.map((company) => company.value).toString()
    )

  const handleApply = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? companies : ""
    var searchBranch = branch && branches ? branches : ""
    var searchDepartment = departments && departments ? departments : ""
    var searchDesignation = designations && designations ? designations : ""
    var searchCity = cities && cities ? cities : ""
    var searchFromDate = employeeData.fromDate
      ? moment(employeeData.fromDate).format("DD-MM-YYYY")
      : ""
    var searchToDate = employeeData.toDate
      ? moment(employeeData.toDate).format("DD-MM-YYYY")
      : ""
    var searchActiveStatus = employeeActive === true ? "inActive" : "active"

    var searchFilter = {}
    searchFilter.status = searchActiveStatus
    searchFilter.isManageHRMS = true
    if (searchCompany) {
      searchFilter.companyId = searchCompany
    }
    if (searchBranch) {
      searchFilter.branchId = searchBranch
    }
    if (searchDepartment) {
      searchFilter.departmentId = searchDepartment
    }
    if (searchDesignation) {
      searchFilter.designationId = searchDesignation
    }
    if (searchFromDate) {
      searchFilter.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.toDate = searchToDate
    }
    if (searchCity) {
      searchFilter.cityId = searchCity
    }
    //     setSearchValueList(searchFilter)
    dispatch(employeeReportAction.loadRecords(searchFilter))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  //table data

  let slNo = 0
  const employeeReportTable =
    !isEmpty(employee_report) && employee_report.length > 0
      ? employee_report.map((data) => {
          slNo = slNo + 1
          const doj =
            !isEmpty(data.doj) && data.doj
              ? moment(data.doj).format("DD-MM-YYYY")
              : ""
          const dob =
            !isEmpty(data.dob) && data.dob
              ? moment(data.dob).format("DD-MM-YYYY")
              : ""
          const shiftName =
            !isEmpty(recordsMetaData) &&
            recordsMetaData.shiftOptions &&
            recordsMetaData.shiftOptions.length > 0
              ? recordsMetaData.shiftOptions.find(
                  (_) => _.value === data.shiftId
                ) &&
                recordsMetaData.shiftOptions.find(
                  (_) => _.value === data.shiftId
                ).label
              : ""
          const cityName =
            !isEmpty(recordsMetaData) &&
            recordsMetaData.cityOptions &&
            recordsMetaData.cityOptions.length > 0
              ? recordsMetaData.cityOptions.find(
                  (_) => _.value === data.cityId
                ) &&
                recordsMetaData.cityOptions.find((_) => _.value === data.cityId)
                  .label
              : ""
          const roleName =
            !isEmpty(recordsMetaData) &&
            recordsMetaData.roleOptions &&
            recordsMetaData.roleOptions.length > 0
              ? recordsMetaData.roleOptions.find(
                  (_) => _.value === data.roleId
                ) &&
                recordsMetaData.roleOptions.find((_) => _.value === data.roleId)
                  .label
              : ""
          console.log(roleName, cityName, shiftName, "label values")
          return {
            sNo: slNo,
            _id: data._id,
            company: data.companyName,
            companyId: data.companyId,
            branch: data.branchName,
            empCode: data.empCode,
            empName: data.name,
            dob: !isEmpty(dob) ? dob : "--",
            department: data.departmentName,
            designation: data.designationName,
            // role: data.role,
            role: roleName ? roleName : "--",
            doj: !isEmpty(doj) ? doj : "--",
            gender: data.gender,
            mobileNo: data.mobileNo,
            bloodGroup: data.bloodGroup,
            companyEmail: data.companyEmail,
            // timeShift: data.timeShift,
            timeShift: shiftName ? shiftName : "--",
            homeTown: data.homeTown,
            // city: data.city,
            city: cityName ? cityName : "--",
            maritalStatus: data.maritalStatus,
            status: data.status,
          }
        })
      : []

  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "company",
      text: "Company",
      sort: true,
      // csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      sort: true,
      // csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "empCode",
      text: "Emp Code",
      sort: true,
      // csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "empName",
      text: "Emp Name",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "dob",
      text: "DOB",
      sort: true,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "department",
      text: "Department",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "designation",
      text: "Designation",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "role",
      text: "Role",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "doj",
      text: "Date of Join",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "gender",
      text: "Gender",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "mobileNo",
      text: "Mobile No",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "bloodGroup",
      text: "Blood Group",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "companyEmail",
      text: "Company Email",
      sort: true,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "timeShift",
      text: "Time Shift",
      sort: true,
      headerStyle: {
        minWidth: "169px",
      },
    },
    {
      dataField: "homeTown",
      text: "Home Town",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
      headerStyle: {
        minWidth: "106px",
      },
    },
    {
      dataField: "maritalStatus",
      text: "Marital Status",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status == 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
            }`}
            color={row.status == 1 ? "success" : "danger"}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "132px",
      },
    },
  ]

  const options = {
    sizePerPage: 50,
    totalSize: employee_report.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  // Reset functionality

  const [pageLoad, setPageLoad] = useState(false)
  const resetFormDetails = () => {
    setCompany([])
    setBranch([])
    setDesignation([])
    setCity([])
    setDepartment([])
    setEmployeeData({
      fromDate: "",
      toDate: "",
    })
    setEmployeeActive(false)
    dispatch(
      employeeReportAction.loadRecords({
        status: "active",
        isManageHRMS: true,
      })
    )
  }

  //Download functionality

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = companies && companies ? companies : ""
    var searchBranch = branch && branches ? branches : ""
    var searchDepartment = departments && departments ? departments : ""
    var searchDesignation = designations && designations ? designations : ""
    var searchCity = cities && cities ? cities : ""
    var searchFromDate = employeeData.fromDate
      ? moment(employeeData.fromDate).format("DD-MM-YYYY")
      : ""
    var searchToDate = employeeData.toDate
      ? moment(employeeData.toDate).format("DD-MM-YYYY")
      : ""
    var searchActiveStatus = employeeActive === true ? "inActive" : "active"

    var searchFilter = {}
    searchFilter.status = searchActiveStatus
    searchFilter.isManageHRMS = true
    if (searchCompany) {
      searchFilter.companyId = searchCompany
    }
    if (searchBranch) {
      searchFilter.branchId = searchBranch
    }
    if (searchDepartment) {
      searchFilter.departmentId = searchDepartment
    }
    if (searchDesignation) {
      searchFilter.designationId = searchDesignation
    }
    if (searchFromDate) {
      searchFilter.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.toDate = searchToDate
    }
    if (searchCity) {
      searchFilter.cityId = searchCity
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_all_employee`, searchFilter)
      .then((response) => {
        console.log(response.data, "response")

        const equipmentHrExportExcel = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
              const doj =
                !isEmpty(data.doj) && data.doj
                  ? moment(data.doj).format("DD-MM-YYYY")
                  : ""
              const dob =
                !isEmpty(data.dob) && data.dob
                  ? moment(data.dob).format("DD-MM-YYYY")
                  : ""
              const shiftName =
                !isEmpty(recordsMetaData) &&
                recordsMetaData.shiftOptions &&
                recordsMetaData.shiftOptions.length > 0
                  ? recordsMetaData.shiftOptions.find(
                      (_) => _.value === data.shiftId
                    ) &&
                    recordsMetaData.shiftOptions.find(
                      (_) => _.value === data.shiftId
                    ).label
                  : ""
              const cityName =
                !isEmpty(recordsMetaData) &&
                recordsMetaData.cityOptions &&
                recordsMetaData.cityOptions.length > 0
                  ? recordsMetaData.cityOptions.find(
                      (_) => _.value === data.cityId
                    ) &&
                    recordsMetaData.cityOptions.find(
                      (_) => _.value === data.cityId
                    ).label
                  : ""
              const roleName =
                !isEmpty(recordsMetaData) &&
                recordsMetaData.roleOptions &&
                recordsMetaData.roleOptions.length > 0
                  ? recordsMetaData.roleOptions.find(
                      (_) => _.value === data.roleId
                    ) &&
                    recordsMetaData.roleOptions.find(
                      (_) => _.value === data.roleId
                    ).label
                  : ""
              console.log(roleName, cityName, shiftName, "label values")
              const homeTown = !isEmpty(data.homeTown)
                ? JSON.stringify(data.homeTown).replace(/","/g, "\n")
                : "--"
              return {
                sNo: index + 1,
                _id: data._id,
                company: data.companyName,
                companyId: data.companyId,
                branch: data.branchName,
                empCode: data.empCode,
                empName: data.name,
                dob: !isEmpty(dob) ? dob : "--",
                department: data.departmentName,
                designation: data.designationName,
                // role: data.role,
                role: roleName ? roleName : "--",
                doj: !isEmpty(doj) ? doj : "--",
                gender: data.gender,
                mobileNo: data.mobileNo,
                bloodGroup: data.bloodGroup,
                companyEmail: data.companyEmail,
                // timeShift: data.timeShift,
                timeShift: shiftName ? shiftName : "--",
                homeTown: homeTown,
                // city: data.city,
                city: cityName ? cityName : "--",
                maritalStatus: data.maritalStatus,
                status: data.status == 1 ? "Active" : "Inactive",
              }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "S.No,Company,Branch,Emp Code,Employee Name,DOB,Department,Designation,Role,Date of Join,Gender,Mobile No,Blood Group,Company Email,Time Shift,Home Town,City,Marital Status,Status",
          ]

          let usersCsv = !isEmpty(equipmentHrExportExcel)
            ? equipmentHrExportExcel.reduce((acc, user) => {
                const {
                  sNo,
                  company,
                  branch,
                  empCode,
                  empName,
                  dob,
                  department,
                  designation,
                  role,
                  doj,
                  gender,
                  mobileNo,
                  bloodGroup,
                  companyEmail,
                  timeShift,
                  homeTown,
                  city,
                  maritalStatus,
                  status,
                } = user
                acc.push([
                  sNo,
                  company,
                  branch,
                  empCode,
                  empName,
                  dob,
                  department,
                  designation,
                  role,
                  doj,
                  gender,
                  mobileNo,
                  bloodGroup,
                  companyEmail,
                  timeShift,
                  homeTown,
                  city,
                  maritalStatus,
                  status,
                ])

                console.log("test", acc)
                return acc
              }, [])
            : false
          console.log(usersCsv, "usersCsv")

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "EmployeeReport.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Company</Label>

                      <Select
                        type="text"
                        name="company"
                        value={company}
                        onChange={(e) => setCompany(e)}
                        options={
                          recordsMetaData ? recordsMetaData.companyOptions : []
                        }
                        isMulti
                        placeholder="Select Company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Branch</Label>
                      <Select
                        type="text"
                        name="branch"
                        isMulti
                        value={branch}
                        onChange={(e) => setBranch(e)}
                        options={branchListOptions}
                        placeholder="Select branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Department"}
                        </Label>
                      </div>
                      <Select
                        name="department"
                        value={department}
                        onChange={(e) => setDepartment(e)}
                        isMulti
                        options={
                          recordsMetaData
                            ? recordsMetaData.departmentOptions
                            : []
                        }
                        placeholder="Select Department"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Designation"}
                        </Label>
                      </div>
                      <Select
                        name="designation"
                        value={designation}
                        isMulti
                        onChange={(e) => setDesignation(e)}
                        options={
                          recordsMetaData
                            ? recordsMetaData.designationOptions
                            : []
                        }
                        placeholder="Select Designation"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"City"}
                        </Label>
                      </div>
                      <Select
                        name="city"
                        value={city}
                        isMulti
                        onChange={(e) => setCity(e)}
                        options={
                          recordsMetaData ? recordsMetaData.cityOptions : []
                        }
                        placeholder="Select City"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Event From Date"}
                        >
                          {"Join From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="fromDate"
                        value={employeeData.fromDate}
                        max={employeeData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Event To Date"}>
                          {"Join To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="toDate"
                        value={employeeData.toDate}
                        min={employeeData.fromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                      <div className="d-flex flex-row">
                        {statusList.map((status, index) => {
                          return (
                            <div className="d-flex flex-row" key={index}>
                              <Input
                                type="checkbox"
                                name="employeeActive"
                                value={status.value}
                                // defaultChecked={
                                //   employeeActive != status.value
                                //     ? false
                                //     : true
                                // }
                                checked={employeeActive === status.value}
                                // className={status.value ? "audit-status-border" : ""}
                                onChange={(e) =>
                                  handleStatusChange(e, status.value)
                                }
                                className="font-size-15"
                              />
                              <Label
                                className="mx-2"
                                style={{ marginTop: "2px", fontSize: "12px" }}
                              >
                                {status.label}
                              </Label>
                            </div>
                          )
                        })}
                        {/* <Input
                            type="checkbox"
                            name="employeeActive"
                            onChange={(e) => {
                              setEmployeeActive(e.target.checked)
                            }}
                            value={employeeActive}
                            id="checkbox"
                            className="font-size-15"
                          />
                          <Label className="mx-2 mt-1">Inactive Employee</Label> */}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          onClick={() => resetFormDetails()}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleApply(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="_id"
                  columns={columns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={employeeReportTable}
                      columns={columns}
                      search
                      exportCSV={{
                        onlyExportFiltered: true,
                        exportAll: false,
                      }}
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row">
                              <Col className="mb-3" md="4">
                                <div className="d-flex flex-row">
                                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                    <div
                                      className="position-relative mt-7"
                                      style={searchBtnStyle || null}
                                    >
                                      <SearchBar {...props.searchProps} />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </div>{" "}
                              </Col>
                              <Col md="8">
                                <div
                                  style={{
                                    float: "right",
                                  }}
                                >
                                  <Button
                                    className="btn btn-primary"
                                    onClick={exportToCsv}
                                    id="download"
                                    style={{
                                      backgroundColor: "#e40d8c",
                                      color: "white",
                                      border: "none",
                                      marginBottom: "20px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    Download
                                  </Button>
                                </div>
                              </Col>
                              <Col md="12" lg="12" xl="12" sm="12" xs="12">
                                <BootstrapTable
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  keyField="equipment"
                                  bordered={true}
                                  columns={columns}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "6.7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
EmployeeReport.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  //isInvalid:PropTypes.any
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmployeeReport)
)
